import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { connect, useDispatch } from "react-redux";
import jsPDF from "jspdf";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import robotoLight from "../../helpers/fonts/robotoLight";
import robotoBold from "../../helpers/fonts/robotoBold";
import logo from "../../helpers/onedose_black.png";
import { approveOtp } from "../../actions/agreement/approveOtp";
import { professionsv2 } from "../../actions/v3/professions"
import { careProvidersv2 } from "../../actions/v3/careProviders"
import { startApplicationv2 } from "../../actions/v3/startApplication";
function NewApplication(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [row, setRow] = useState(3);
    const [mounted, setMounted] = useState(false);
    const [veriCode, setVeriCode] = useState("");
    const [displayCard, setDisplayCard] = useState("triageform");
    const [professionId, setProfessionId] = useState("");
    const [relativeName, setRelativeName] = useState("");
    const [relativeSurname, setRelativeSurname] = useState("");
    const [relativeNationalIdentifier, setRelativeNationalIdentifier] = useState("");
    const [relativeBirthDateYear, setRelativeBirthDateYear] = useState(0);
    const [relativeBirthDateMonth, setRelativeBirthDateMonth] = useState(0);
    const [relativeBirthDateDay, setRelativeBirthDateDay] = useState(0);
    const [relativeGender, setRelativeGender] = useState(1);
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);
    const [careProviderData, setCareProviderData] = useState();
    const [institution, setInstitution] = useState(0);
    const [cures, setCure] = useState(
        [
            {
                r1: "",
                r2: "",
                r3: "",
                r4: "",
            },
        ]
    );
    const [medicines, setMedicine] = useState([
        {
            r1: "",
            r2: "",
        },
    ]);
    const [addictions, setAddiction] = useState([
        {
            r1: "",
            r2: "",
        },
    ]);
    const [operations, setOperation] = useState([{}]);
    const [pdfFile, setPdfFile] = useState("");
    const [allergies, setAllergy] = useState(false);
    const [relativeDisease, setRelativeDisease] = useState(false);
    const [approve, setApprove] = useState(false);
    const [approve2, setApprove2] = useState(false);
    const [approvePatient, setApprovePatient] = useState(false);

    const [form, setForm] = useState({
        "Görüş Almak İstediğiniz Uzmanlık Alanı": "",
        "Görüş Almak İstediğiniz Hastalık": "",
        "Görüş Almak İstediğiniz Konu": {
            "Yakın zamanda konulan bir teşhis hakkında görüş almak istiyorum": "",
            "Planlanan bir ameliyat hakkında görüş almak istiyorum": "",
            "Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir tıbbi sorunumla ilgili görüş almak istiyorum": "",
            "Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında görüş almak istiyorum": "",
            "Hastalığımla ilişkili cevaplanmasını istediğim spesifik sorularım var": "",
        },
        "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi": "",
        "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri": "",
        "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar": "",
        "Geçirilmiş Operasyonlar": {},
        "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {},
        "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar": "",
        "Kullanımı devam eden ilaçlar": {},
        Alışkanlıklar: {},
        "Alerji durumunuz": "",
        "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?": "",
    });

    useEffect(() => {
        dispatch(professionsv2(institution));
    }, [dispatch]);

    useEffect(() => {
        localStorage.setItem("whichOne", "")
    }, [localStorage])


    const handleExportToPDF = () => {
        return new Promise((resolve, reject) => {
            try {
                const doc = new jsPDF({
                    orientation: "p",
                    unit: "pt",
                    format: "a4",
                });

                doc.addFileToVFS("Roboto-Regular.ttf", robotoLight);
                doc.addFileToVFS("Roboto-Bold.ttf", robotoBold);
                doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
                doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
                doc.setFont("Roboto", "normal");

                let offsetY = 50;
                const pageWidth = 595;
                const pageHeight = 842;
                const textWidth = pageWidth - 60;

                doc.addImage(logo, "PNG", 545, 6, 40, 30);

                // Başlık
                doc.setFontSize(16);
                doc.setFont("Roboto", "bold");
                doc.text("İkinci Görüş Başvuru Formu", 10, 23);
                offsetY += 20;
                doc.setLineWidth(1);
                doc.line(10, 40, 595 - 10, 40);

                doc.setFontSize(12);

                // Form verilerini PDF'e ekle
                for (const property in form) {
                    const value = form[property];
                    if (typeof value === "object") {
                        offsetY += 10;
                        doc.setFont("Roboto", "bold");

                        // Yeni sayfa kontrolü
                        if (offsetY + 20 > pageHeight) {
                            doc.addPage();
                            offsetY = 30;
                        }

                        doc.text(property, 10, offsetY);
                        offsetY += 20;

                        for (const subProperty in value) {
                            const subValue = value[subProperty];
                            doc.setFont("Roboto", "normal");

                            const textLines = doc.splitTextToSize(
                                `${subProperty}: ${subValue}`,
                                textWidth
                            );

                            for (let i = 0; i < textLines.length; i++) {
                                // Yeni sayfa kontrolü
                                if (offsetY + 15 > pageHeight) {
                                    doc.addPage();
                                    offsetY = 30;
                                }

                                doc.text(textLines[i], 20, offsetY);
                                offsetY += 15;
                            }
                        }

                        offsetY += 10;
                    } else {
                        doc.setFont("Roboto", "normal");

                        const textLines = doc.splitTextToSize(
                            `${property}: ${value}`,
                            textWidth
                        );

                        for (let i = 0; i < textLines.length; i++) {
                            // Yeni sayfa kontrolü
                            if (offsetY + 15 > pageHeight) {
                                doc.addPage();
                                offsetY = 30;
                            }

                            doc.text(textLines[i], 20, offsetY);
                            offsetY += 15;
                        }
                    }
                }

                const pdfAsBase64 = doc.output("datauristring");
                setPdfFile(pdfAsBase64);

                resolve(pdfAsBase64); // PDF başarıyla oluşturuldu ve base64 olarak döndürülüyor
            } catch (error) {
                reject(error); // Bir hata oluştu
            }
        });
    };

    async function handleSubmit(event) {
        event.preventDefault();
        if (!approve || !approve2) {
            Swal.fire({
                icon: "error",
                title: "Formu onaylayınız...",
                text: "Tıbbi ikinci görüş beyanı bilgilendirme metni ve Aydınlatma Metni'ni okuyup onaylamanız gerekmektedir.",
                confirmButtonText: "Anladım",
                footer:
                    '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
            });
            return;
        }

        if (form["Görüş Almak İstediğiniz Uzmanlık Alanı"] === "") {
            Swal.fire({
                icon: "error",
                title: "Zorunlu alanlar doldurulmalı",
                text: "Lütfen zorunlu alanları doldurunuz.",
                confirmButtonText: "Anladım",
                footer:
                    '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
            });
            return;
        }
        if (form["Görüş Almak İstediğiniz Hastalık"] === "") {
            Swal.fire({
                icon: "error",
                title: "Zorunlu alanlar doldurrulmalı",
                text: "Lütfen zorunlu alanları doldurunuz.",
                confirmButtonText: "Anladım",
                footer:
                    '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
            });
            return;
        }

        try {
            const pdfBase64 = await handleExportToPDF();

            const surveyData = {
                "surveyName": "İkinci Görüş Talep Formu",
                "data": JSON.stringify(form),
                "pdfData": pdfBase64,
            }

            const representedPatientInformation = {
                "name": relativeName,
                "surname": relativeSurname,
                "nationalIdentifier": relativeNationalIdentifier,
                "birthDateYear": relativeBirthDateYear,
                "birtDateMonth": relativeBirthDateMonth,
                "birthDateDay": relativeBirthDateDay,

            }
            dispatch(startApplicationv2(careProviderData, surveyData, institution, representedPatientInformation))
            setMounted(true);
        } catch (error) {
            console.error("PDF oluşturma işleminde bir hata oluştu:", error);

        }

    }


    /** */


    useEffect(() => {
        if (props.startApplicationv2.done) {
            navigate("/file-uploadv2/" + props.startApplicationv2?.startApplicationv2?.result);
        }
    })


    useEffect(() => {

        if (props.careProvidersv2.done) {
            setCareProviderData(props.careProvidersv2?.careProvidersv2?.result?.data)
        }

    }, [props.careProvidersv2])


    return (
        <div  >
            <Header />
            <div className="md:justify-center me-4">
                <div className="mb-10" id="triageformcard" >
                    <div className="pt-10 md:ml-64 ps-5">
                        <ol
                            className="flex items-center whitespace-nowrap min-w-0"
                            aria-label="Breadcrumb"
                        >
                            <li className="text-sm">
                                <a
                                    onClick={() => {
                                        setDisplayCard("forwho");
                                    }}
                                    className="flex items-center text-gray-500 hover:text-blue-600"
                                    href="#"
                                >
                                    Yeni Başvuru
                                    <svg
                                        className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </a>
                            </li>
                            <li
                                className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
                                aria-current="page"
                            >
                                Talep Formu
                            </li>
                        </ol>
                    </div>
                    <hr className="divide-y mt-2" />
                    <h1 className="md:ml-64 ps-5 mt-5 text-3xl text-start font-semibold">
                        İkinci Görüş Talep Formus
                    </h1>
                    <div className="md:ml-64 dark:bg-dark ps-5 mt-5">
                        <div className="text-start">
                            <label
                                htmlFor="hs-select-label"
                                className="block text-sm font-medium mb-2 dark:text-white"
                            >
                                Görüş Almak İstediğiniz Uzmanlık Alanı
                                <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                                    *
                                    <span
                                        className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                        role="tooltip"
                                    >
                                        Bu alanları doldurmak zorunludur
                                    </span>
                                </b>
                            </label>
                            <select
                                onChange={(e) => {
                                    const selectedOptionText =
                                        e.target.options[e.target.selectedIndex].text;

                                    setForm((prevState) => ({
                                        ...prevState,
                                        "Görüş Almak İstediğiniz Uzmanlık Alanı":
                                            selectedOptionText,
                                    }));
                                    setProfessionId(e.target.value);
                                    dispatch(careProvidersv2(e.target.value, institution));
                                }}
                                required
                                id="hs-select-label"
                                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            >
                                <option selected>Lütfen Seçiniz</option>
                                {props.professionsv2.done ? (
                                    props.professionsv2?.professionsv2?.result?.data
                                        .sort((a, b) =>
                                            a.professionName.localeCompare(b.professionName)
                                        ) // Alfabetik sıralama
                                        .map((element, index) => (
                                            <option value={element.code} key={index}>
                                                {element.professionName}
                                            </option>
                                        ))
                                ) : (
                                    <option defaultValue="">Alanlar yüklenemedi</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <div className="md:ml-64 dark:bg-dark ps-5 mt-5">
                        <div className="text-start">
                            <label
                                htmlFor="hs-select-label"
                                className="block text-sm font-medium mb-2 dark:text-white"
                            >
                                Görüş Almak İstediğiniz Hekim
                                <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                                    *
                                    <span
                                        className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                        role="tooltip"
                                    >
                                        Bu alanları doldurmak zorunludur
                                    </span>
                                </b>
                            </label>
                            <select
                                onChange={(e) => {
                                    const selectedId = e.target.value;
                                    const selectedCareProvider = props.careProvidersv2?.careProvidersv2?.result?.data.find(element => element.careProviderId === selectedId);
                                    setCareProviderData(selectedCareProvider);
                                }}
                                required
                                id="hs-select-label"
                                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            >
                                <option selected>Lütfen Seçiniz</option>
                                {props.careProvidersv2.done ? (
                                    props.careProvidersv2?.careProvidersv2?.result?.data?.length === 0 ? (
                                        <option selected defaultValue="">Seçtiğiniz bölüme ait bir doktor bulunmamaktadır</option>
                                    ) : (
                                        props.careProvidersv2?.careProvidersv2?.result?.data
                                            .sort((a, b) => a.fullName.localeCompare(b.fullName))
                                            .map((element, index) => (
                                                <option value={element.careProviderId} key={index}>
                                                    {element.fullName}
                                                </option>
                                            ))
                                    )
                                ) : (
                                    <option selected defaultValue="">Lütfen uzmanlık alanını seçiniz</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <label
                            htmlFor="input-label"
                            className="text-start block text-sm font-medium mb-2 dark:text-white"
                        >
                            Görüş Almak İstediğiniz Hastalık
                            <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                                *
                                <span
                                    className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                    role="tooltip"
                                >
                                    Bu alanları doldurmak zorunludur
                                </span>
                            </b>
                        </label>
                        <input
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Hastalık": e.target.value,
                                }));
                            }}
                            required
                            type="text"
                            id="input-label"
                            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Görüş almak istediğiniz hastalığınızı giriniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <label
                            htmlFor="input-label"
                            className="text-start block text-sm font-medium mb-2 dark:text-white"
                        >
                            Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi
                        </label>
                        <input
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi":
                                        e.target.value,
                                }));
                            }}
                            type="text"
                            id="input-label"
                            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen bir tarih giriniz. (Örn; 2 yıl önce, Ağustos 2022)"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="flex">
                            <input
                                type="checkbox"
                                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                                id="yakin-konulan-teshis"
                                onChange={(e) => setShow(e.target.checked)}
                            />
                            <label
                                htmlFor="yakin-konulan-teshis"
                                className="text-start block text-sm font-medium mb-2 dark:text-white"
                            >
                                Yakın zamanda konulan bir teşhis hakkında görüş almak istiyorum
                            </label>
                        </div>
                        <textarea
                            disabled={!show}
                            onClick={(e) => { setRow(12) }}
                            onBlur={(e) => { setRow(3) }}
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Konu": {
                                        ...prevState["Görüş Almak İstediğiniz Konu"],
                                        "Yakın zamanda konulan bir teşhis hakkında görüş almak istiyorum": e.target.value,
                                    },
                                }));
                            }}
                            type="text"
                            id=""
                            rows={row}
                            className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen detay giriniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="flex">
                            <input
                                type="checkbox"
                                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                                id="planlanan-ameliyat"
                                onChange={(e) => setShow2(e.target.checked)}
                            />
                            <label
                                htmlFor="planlanan-ameliyat"
                                className="text-start block text-sm font-medium mb-2 dark:text-white"
                            >
                                Planlanan bir ameliyat hakkında görüş almak istiyorum
                            </label>
                        </div>
                        <textarea
                            disabled={!show2}
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Konu": {
                                        ...prevState["Görüş Almak İstediğiniz Konu"],
                                        "Planlanan bir ameliyat hakkında görüş almak istiyorum": e.target.value,
                                    },
                                }));
                            }}
                            type="text"
                            id="planlanan-ameliyat"
                            rows={3}
                            className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen detay giriniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="flex">
                            <input
                                type="checkbox"
                                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                                id="kronik-problem"
                                onChange={(e) => setShow3(e.target.checked)}
                            />
                            <label
                                htmlFor="kronik-problem"
                                className="text-start block text-sm font-medium mb-2 dark:text-white"
                            >
                                Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir
                                tıbbi sorunumla ilgili görüş almak istiyorum
                            </label>
                        </div>
                        <textarea
                            disabled={!show3}
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Konu": {
                                        ...prevState["Görüş Almak İstediğiniz Konu"],
                                        "Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir tıbbi sorunumla ilgili görüş almak istiyorum": e.target.value,
                                    },
                                }));
                            }}
                            type="text"
                            id=""
                            rows={3}
                            className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen detay giriniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="flex">
                            <input
                                type="checkbox"
                                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                                id="tedavi-planı"
                                onChange={(e) => setShow4(e.target.checked)}
                            />
                            <label
                                htmlFor="tedavi-planı"
                                className="text-start block text-sm font-medium mb-2 dark:text-white"
                            >
                                Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında
                                görüş almak istiyorum
                            </label>
                        </div>
                        <textarea
                            disabled={!show4}
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Konu": {
                                        ...prevState["Görüş Almak İstediğiniz Konu"],
                                        "Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında görüş almak istiyorum": e.target.value,
                                    },
                                }));
                            }}
                            type="text"
                            id=""
                            rows={3}
                            className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen detay giriniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="flex">
                            <input
                                type="checkbox"
                                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                                id="spesifik-sorular"
                                onChange={(e) => setShow5(e.target.checked)}
                            />
                            <label
                                htmlFor="spesifik-sorular"
                                className="text-start block text-sm font-medium mb-2 dark:text-white"
                            >
                                Hastalığımla ilişkili cevaplanmasını istediğim spesifik sorularım var
                            </label>
                        </div>
                        <textarea
                            disabled={!show5}
                            readOnly
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş Almak İstediğiniz Konu": {
                                        ...prevState["Görüş Almak İstediğiniz Konu"],
                                        "Hastalığımla ilişkili cevaplanmasını istediğim spesifik sorularım var": e.target.value,
                                    },
                                }));
                            }}
                            type="text"
                            rows={3}
                            className="py-3 px-4 disabled:opacity-40 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen detay giriniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <label
                            htmlFor="kafkas5"
                            className="text-start block text-sm font-medium mb-2 dark:text-white"
                        >
                            Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri
                        </label>
                        <textarea
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri":
                                        e.target.value,
                                }));
                            }}
                            rows="4"
                            type="text"
                            id="kafkas5"
                            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen görüş almak istediğiniz hastalığınız ile ilgili daha önce başvurduğunuz hekim/sağlık merkezleri ve başvuru tarihlerini belirtiniz."
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <label
                            htmlFor="kafkas6"
                            className="text-start block text-sm font-medium mb-2 dark:text-white"
                        >
                            Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar
                        </label>
                        <textarea
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar":
                                        e.target.value,
                                }));
                            }}
                            rows="4"
                            type="text"
                            id="kafkas6"
                            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Lütfen belirtiniz"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <label
                            htmlFor="kafkas7"
                            className="text-start block text-sm font-medium mb-2 dark:text-white"
                        >
                            Geçirilmiş Operasyonlar
                        </label>

                        {operations.map((element, index) => (
                            <textarea
                                key={index}
                                onChange={(e) => {
                                    setForm((prevState) => ({
                                        ...prevState,
                                        "Geçirilmiş Operasyonlar": {
                                            ...prevState["Geçirilmiş Operasyonlar"],
                                            ["Geçirilmiş Operasyon " + index]: e.target.value,
                                        },
                                    }));
                                }}
                                rows="4"
                                type="text"
                                id="kafkas7"
                                className=" mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                placeholder="Lütfen görüş almak istediğiniz hastalığınız ile ilgili operasyon adı, tarihi ve operasyonun gerçekleştirildiği sağlık merkezi bilgilerini giriniz"
                            />
                        ))}
                        <div className="flex justify-end">
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    const newOperations = [...operations];
                                    newOperations.pop();
                                    setOperation(newOperations);
                                }}
                                href="#"
                                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
                            >
                                <i className="fa-light fa-minus me-1"></i>
                                Daha az
                            </a>
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOperation([...operations, { text: "" }]);
                                }}
                                href="#"
                                className=" block text-sm font-medium mb-2 onedose-color mt-2"
                            >
                                <i className="fa-light fa-plus me-1"></i>
                                Daha fazla
                            </a>
                        </div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <h1 className="text-start mb-2 text-xl font-semibold">
                            Hastalık İle İlgili Günümüze Dek Alınan Tedaviler:
                        </h1>
                        {cures.map((element, index) => (
                            <div key={index} className="grid grid-cols-2 gap-2">
                                <div>
                                    <label
                                        htmlFor={`question_10_1_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        Tedavi Adı
                                    </label>
                                    <input
                                        onChange={(e) => {
                                            setCure(
                                                cures.map((c, i) =>
                                                    i === index ? { ...c, r1: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                                                    ...prevState[
                                                    "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                                                    ],
                                                    ["Tedavi Adı " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        name={`question_10_1_${index}`}
                                        type="text"
                                        id={`q9_${index}`}
                                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                        placeholder="Tedavi/İlaç adını giriniz"
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor={`question_10_2_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        Tedavi Durumu
                                    </label>
                                    <select
                                        onChange={(e) => {
                                            setCure(
                                                cures.map((c, i) =>
                                                    i === index ? { ...c, r2: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                                                    ...prevState[
                                                    "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                                                    ],
                                                    ["Tedavi Durumu " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        name={`question_10_2_${index}`}
                                        id={`q10_${index}`}
                                        className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                    >
                                        <option value="" disabled selected>
                                            Lütfen seçiniz
                                        </option>
                                        <option value="Devam Ediyor">Devam ediyor</option>
                                        <option value="Sonlandı">Sonlandı</option>
                                    </select>
                                </div>
                                <div>
                                    <label
                                        htmlFor={`question_10_3_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        Başlangıç Tarihi
                                    </label>
                                    <input
                                        onChange={(e) => {
                                            setCure(
                                                cures.map((c, i) =>
                                                    i === index ? { ...c, r3: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                                                    ...prevState[
                                                    "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                                                    ],
                                                    ["Tedavi Başlangıç Tarihi " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        id={`question_10_3_${index}`}
                                        name={`q11_${index}`}
                                        type="text"
                                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                        placeholder="Örn 2018"
                                    />
                                </div>
                                <div>
                                    {element.r2 == "Sonlandı" ? (
                                        <div>
                                            <label
                                                htmlFor={`question_10_4_${index}`}
                                                className="text-start block text-sm font-medium mb-2 dark:text-white"
                                            >
                                                Bitiş Tarihi
                                            </label>
                                            <input
                                                type="text"
                                                onChange={(e) => {
                                                    setCure(
                                                        cures.map((c, i) =>
                                                            i === index ? { ...c, r4: e.target.value } : c
                                                        )
                                                    );
                                                    setForm((prevState) => ({
                                                        ...prevState,
                                                        "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler":
                                                        {
                                                            ...prevState[
                                                            "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                                                            ],
                                                            ["Tedavi Bitiş Tarihi " + index]:
                                                                e.target.value,
                                                        },
                                                    }));
                                                }}
                                                id={`q12_${index}`}
                                                name={`question_10_4_${index}`}
                                                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                                placeholder="Örn 2022"
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ))}

                        <div className="flex justify-end">
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    const newCures = [...cures];
                                    newCures.pop();
                                    setCure(newCures);
                                }}
                                href="#"
                                htmlFor="input-label"
                                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
                            >
                                <i className="fa-light fa-minus me-1"></i>
                                Daha az
                            </a>
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    setCure([...cures, { r1: "", r2: "", r3: "", r4: "" }]);
                                }}
                                href="#"
                                htmlFor="input-label"
                                className=" block text-sm font-medium mb-2 onedose-color mt-2"
                            >
                                <i className="fa-light fa-plus me-1"></i>
                                Daha fazla
                            </a>
                        </div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <label
                            htmlFor="input-label1"
                            className="text-start block text-sm font-medium mb-2 dark:text-white"
                        >
                            Görüş Alınmak İstenen Hastalık Dışında Varsa Diğer Hastalıklar
                            (Özgeçmiş)
                        </label>
                        <textarea
                            onChange={(e) => {
                                setForm((prevState) => ({
                                    ...prevState,
                                    "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar":
                                        e.target.value,
                                }));
                            }}
                            rows="4"
                            type="text"
                            id="input-label1"
                            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="Bilinen diğer hastalıklar"
                        />
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <h1 className="text-start mb-2 text-xl font-semibold">
                            Kullanımı Devam Eden İlaçlar :
                        </h1>
                        {medicines.map((element, index) => (
                            <div key={index} className="grid grid-cols-2 gap-2">
                                <div>
                                    <label
                                        htmlFor={`question_20_1_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        İlaç Adı ve Dozu
                                    </label>
                                    <input
                                        onChange={(e) => {
                                            setMedicine(
                                                medicines.map((c, i) =>
                                                    i === index ? { ...c, r1: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Kullanımı devam eden ilaçlar": {
                                                    ...prevState["Kullanımı devam eden ilaçlar"],
                                                    ["İlaç adı ve dozu " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        id={`question_20_1_${index}`}
                                        type="text"
                                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                        placeholder="İlaç adı ve dozunu giriniz"
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor={`question_10_4_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        Başklangıç Zamanı
                                    </label>
                                    <input
                                        onChange={(e) => {
                                            setMedicine(
                                                medicines.map((c, i) =>
                                                    i === index ? { ...c, r2: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Kullanımı devam eden ilaçlar": {
                                                    ...prevState["Kullanımı devam eden ilaçlar"],
                                                    ["İlaç başlangıç zamanı " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        id={`q12_${index}`}
                                        name={`question_10_4_${index}`}
                                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                    />
                                </div>
                            </div>
                        ))}

                        <div className="flex justify-end">
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    const newMedicines = [...medicines];
                                    newMedicines.pop();
                                    setMedicine(newMedicines);
                                }}
                                href="#"
                                htmlFor="input-label"
                                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
                            >
                                <i className="fa-light fa-minus me-1"></i>
                                Daha az
                            </a>
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMedicine([...medicines, { r1: "", r2: "" }]);
                                }}
                                htmlFor="input-label"
                                href="#"
                                className=" block text-sm font-medium mb-2 onedose-color mt-2"
                            >
                                <i className="fa-light fa-plus me-1"></i>
                                Daha fazla
                            </a>
                        </div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <h1 className="text-start mb-2 text-xl font-semibold">
                            Alışkanlıklar
                        </h1>
                        {addictions.map((element, index) => (
                            <div key={index} className="grid grid-cols-2 gap-2">
                                <div>
                                    <label
                                        htmlFor={`question_20_1_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        Alışkanlığınızın Türü
                                    </label>
                                    <input
                                        onChange={(e) => {
                                            setAddiction(
                                                addictions.map((c, i) =>
                                                    i === index ? { ...c, r1: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                Alışkanlıklar: {
                                                    ...prevState["Alışkanlıklar"],
                                                    ["Alışkanlık " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        id={`question_20_1_${index}`}
                                        type="text"
                                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                        placeholder="Örn: Sigara"
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor={`question_10_4_${index}`}
                                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                                    >
                                        Kullanım Süresi
                                    </label>
                                    <input
                                        onChange={(e) => {
                                            setAddiction(
                                                addictions.map((c, i) =>
                                                    i === index ? { ...c, r2: e.target.value } : c
                                                )
                                            );
                                            setForm((prevState) => ({
                                                ...prevState,
                                                Alışkanlıklar: {
                                                    ...prevState["Alışkanlıklar"],
                                                    ["Kullanım Durumu " + index]: e.target.value,
                                                },
                                            }));
                                        }}
                                        id={`question_10_4_${index}`}
                                        placeholder="Örn haftada 1 paket"
                                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                    />
                                </div>
                            </div>
                        ))}

                        <div className="flex justify-end">
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    const newAddictions = [...addictions];
                                    newAddictions.pop();
                                    setAddiction(newAddictions);
                                }}
                                href="#"
                                htmlFor="input-label"
                                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
                            >
                                <i className="fa-light fa-minus me-1"></i>
                                Daha az
                            </a>
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAddiction([...addictions, { r1: "", r2: "" }]);
                                }}
                                htmlFor="input-label"
                                href="#"
                                className=" block text-sm font-medium mb-2 onedose-color mt-2"
                            >
                                <i className="fa-light fa-plus me-1"></i>
                                Daha fazla
                            </a>
                        </div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="text-start">
                            <label
                                htmlFor="hs-select-label11"
                                className="block text-sm font-medium mb-2 dark:text-white"
                            >
                                Alerji Durumunuz
                            </label>
                            <select
                                onChange={(e) => {
                                    setAllergy(e.target.value);
                                    if (allergies !== "true") {
                                        setForm((prevState) => ({
                                            ...prevState,
                                            "Alerji durumunuz": e.target.value,
                                        }));
                                    }
                                }}
                                id={allergies == true ? null : "question_14"}
                                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            >
                                <option selected>Lütfen Seçiniz</option>
                                <option value="true">Alerjim var</option>
                                <option value="Alerjim yok">Alerjim yok</option>
                            </select>
                        </div>
                        {allergies == "true" ? (
                            <div>
                                <label
                                    htmlFor="input-132"
                                    className="mt-2 text-start block text-sm font-medium mb-2 dark:text-white"
                                >
                                    Alerjilerinizi yazınız
                                </label>
                                <textarea
                                    onChange={(e) => {
                                        if (allergies === "true") {
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Alerji durumunuz": e.target.value,
                                            }));
                                        }
                                    }}
                                    rows="4"
                                    type="text"
                                    id={allergies == true ? "question_14" : null}
                                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                    placeholder="Lütfen alerjilerinizi ve bunlara ait detayları yazınız"
                                />
                            </div>
                        ) : null}
                        <div></div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="text-start">
                            <label
                                htmlFor="hs-select-label11"
                                className="block text-sm font-medium mb-2 dark:text-white"
                            >
                                Görüş Almak İstediğiniz Hastalığı Ailenizde Yaşayan Var mı?
                            </label>
                            <select
                                onChange={(e) => {
                                    setRelativeDisease(e.target.value);
                                    if (relativeDisease !== "true") {
                                        setForm((prevState) => ({
                                            ...prevState,
                                            "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
                                                e.target.value,
                                        }));
                                    }
                                }}
                                id={relativeDisease == true ? null : "question_15"}
                                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            >
                                <option selected>Lütfen Seçiniz</option>
                                <option value="true">Evet</option>
                                <option value="Hayır">Hayır</option>
                            </select>
                        </div>
                        {relativeDisease == "true" ? (
                            <div>
                                <label
                                    htmlFor="input-132"
                                    className="mt-2 text-start block text-sm font-medium mb-2 dark:text-white"
                                >
                                    Lütfen Detay Giriniz (Ailenizde Bu Hastalığı Yaşayan Kişi İle
                                    Alakalı?)
                                </label>
                                <textarea
                                    onChange={(e) => {
                                        if (relativeDisease == "true") {
                                            setForm((prevState) => ({
                                                ...prevState,
                                                "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
                                                    e.target.value,
                                            }));
                                        }
                                    }}
                                    rows="4"
                                    type="text"
                                    id={relativeDisease == true ? "question_15" : null}
                                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                                    placeholder="Yakınlık derecesi (anne, baba, vs), hastalığın süresi ve güncel durum bilgisi"
                                />
                            </div>
                        ) : null}
                        <div></div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        <div className="flex justify-start mt-5">
                            <input
                                checked={approve}
                                data-hs-overlay="#hs-large-modal128"
                                type="checkbox"
                                className="onedose-color shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                id="hs-checkbox-group-1"
                            />
                            <label
                                htmlFor="hs-checkbox-group-1"
                                className="text-sm text-gray-500 ml-3 dark:text-gray-400"
                            >
                                Aydınlatma metnini okuyup onayladım.
                            </label>
                        </div>
                        <div className="flex justify-start mt-5">
                            <input
                                checked={approve2}
                                data-hs-overlay="#hs-large-modal129"
                                type="checkbox"
                                className="onedose-color shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                id="hs-checkbox-group-2"
                            />
                            <label
                                htmlFor="hs-checkbox-group-2"
                                className="text-sm text-gray-500 ml-3 dark:text-gray-400"
                            >
                                Tıbbi İkinci görüş beyanı bilgilendirme metnini okuyup onayladım.
                            </label>
                        </div>
                    </div>
                    <div className="md:ml-64 ps-5 mt-5">
                        {props.startApplicationv2.spinner ? (
                            <button
                                style={{ backgroundColor: `#09C35C` }}
                                type="button"
                                className="mb-10  w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
                            >
                                <span
                                    className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full"
                                    role="status"
                                    aria-label="loading"
                                >
                                </span>
                                Devam ediyor
                            </button>
                        ) : (
                            <button
                                onClick={handleSubmit}
                                style={{ backgroundColor: `#09C35C` }}
                                type="button"
                                className="mb-10  w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
                            >
                                Devam et
                            </button>
                        )}
                    </div>
                </div>
                <div id="m234" className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto">
                    <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all lg:max-w-4xl lg:w-full m-3 lg:mx-auto">
                        <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                            <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                                <button
                                    type="button"
                                    className="hs-dropdown-toggle inline-flex flex-shrink-0 justify-center items-center h-8 w-8 rounded-md text-gray-500 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white transition-all text-sm dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800"
                                    data-hs-overlay="#hs-large-modal"
                                >
                                    <span className="sr-only">Close</span>
                                    <svg
                                        className="w-3.5 h-3.5"
                                        width="8"
                                        height="8"
                                        viewBox="0 0 8 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="p-4 overflow-y-auto">
                                <p className="mt-1 text-gray-800 dark:text-gray-400">
                                    <iframe
                                        width="100%"
                                        height="500vh"
                                        src="https://www.onedose.io/tibbi-ikinci-gorus-yakinim-sozlesmesi/"
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </p>
                            </div>
                            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                <button
                                    type="button"
                                    className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                                    data-hs-overlay="#m234"
                                >
                                    Vazgeç
                                </button>
                                <a
                                    onClick={() => {
                                        setApprovePatient(true);
                                    }}
                                    style={{ backgroundColor: `#09C35C` }}
                                    data-hs-overlay="#m234"
                                    type="button"
                                    className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                                    href="#"
                                >
                                    Okudum Anladım
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="hs-large-modal128" className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto" >
                    <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all lg:max-w-4xl lg:w-full m-3 lg:mx-auto">
                        <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                            <div className="p-4 overflow-y-auto">
                                <iframe
                                    width="100%"
                                    height="500vh"
                                    src="https://www.onedose.io/aydinlatma-metni/"
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                <button
                                    type="button"
                                    className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                                    data-hs-overlay="#hs-large-modal128"
                                >
                                    Vazgeç
                                </button>
                                <a
                                    style={{ backgroundColor: `#09C35C` }}
                                    data-hs-overlay="#hs-large-modal128"
                                    onClick={() => {
                                        setApprove(true)
                                    }}
                                    className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                                    href="javascript:void(0)"
                                >
                                    Okudum Anladım
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="hs-large-modal129" className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto">
                    <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all lg:max-w-4xl lg:w-full m-3 lg:mx-auto">
                        <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                            <div className="p-4 overflow-y-auto">
                                <iframe
                                    width="100%"
                                    height="500vh"
                                    src="https://www.onedose.io/bilimsel-gorus-beyani-bilgilendirme-formu/"
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                <button
                                    type="button"
                                    className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                                    data-hs-overlay="#hs-large-modal129"
                                >
                                    Vazgeç
                                </button>
                                <a
                                    style={{ backgroundColor: `#09C35C` }}
                                    data-hs-overlay="#hs-large-modal129"
                                    onClick={() => {
                                        setApprove2(true)
                                    }}
                                    className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                                    href="javascript:void(0)"
                                >
                                    Okudum Anladım
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" id="myBtn" style={{ display: `none` }} className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" data-hs-overlay="#hs-static-backdrop-modal"></button>
            <div id="hs-static-backdrop-modal" className="hs-overlay hidden w-full h-full fixed top-0 start-0 z-[60] overflow-x-hidden overflow-y-auto pointer-events-none" data-hs-overlay-keyboard="false">
                <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
                    <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                        <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                            <h3 className="font-bold text-gray-800 dark:text-white">
                                Doğrulama kodunu giriniz
                            </h3>
                            <button type="button" className="flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" data-hs-overlay="#hs-static-backdrop-modal">
                                <span className="sr-only">Close</span>
                                <svg className="flex-shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                            </button>
                        </div>
                        <div className="p-4 overflow-y-auto">
                            <input
                                onChange={(e) => {
                                    setVeriCode(e.target.value)
                                }}
                                value={veriCode}
                                type="text"
                                className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600" placeholder="Doğrulama kodunuzu giriniz" />

                        </div>
                        <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                            <button
                                id="closemodal"
                                type="button"
                                className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" data-hs-overlay="#hs-static-backdrop-modal">
                                Vazgeç
                            </button>
                            <button
                                onClick={() => {
                                    dispatch(approveOtp("Aydınlatma metni", veriCode));
                                }}
                                type="button"
                                className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600">
                                Onayla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(NewApplication);
